module.exports = __webpack_public_path__ + "static/media/PoppinsRegular.a871ca72.woff2";